import { useQuery } from '@tanstack/react-query';
import { changeTypeApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

/** @registry Change types reference list, shared by the settings grid and the change form's type picker. */
export function useChangeTypes() {
  return useQuery({
    queryKey: queryKeys.changeTypes.list(),
    queryFn: ({ signal }) =>
      changeTypeApiClient.list({}, toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: { errorContext: 'change types' },
  });
}

export function useChangeType(id: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.changeTypes.detail(id ?? ''),
    queryFn: ({ signal }) =>
      changeTypeApiClient.get(id!, toCancelToken(signal)),
    enabled: !!id,
    staleTime: 0,
    meta: { errorContext: 'change type detail' },
  });
}
